/* eslint-disable no-lone-blocks */
import React, { Component } from 'react';
import { Select, Spin, Empty, DatePicker, InputNumber, Input, Modal, Tooltip } from 'antd';
import { PlusOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { excludesTableStore, excludesUpdateTableStore,optionsStore } from '../../../selectStore';
import postService from '../../../services/httpService';
import networkList from '../../../constants/networkList';
// import networkList from './../../constants/networkList';
import Select2 from '../../FormComponent/select2';
import InputNumberlayer from '../../FormComponent/InputNumberlayer';
import Datepicker from '../../FormComponent/Date';
import Checkboxlayer from '../../FormComponent/CheckboxLayer';
import {UPLOAD_URL} from '../../../constants/app-constants';

const { Option } = Select;
const {homepage} = networkList;
var url = window.location.href
var arr = url.split("/");
var hostname = arr[0] + "//" + arr[2]

class Tableantd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            'table_head': [], 'table_body': [], 'add_more': false, 'add_more_title': null, 'tablebody_name': null
        }

        excludesUpdateTableStore.subscribe(() => {
            this.updateTablebody();
        })
    }

    componentDidMount() {
        let { table_head, table_body, add_more, add_more_title } = this.props.table_data;
        let subfeilds;
        table_body.map((subfeild, key) => {
            let feild = subfeild.feilds;
            feild.map((feilds1, keys) => {
                subfeilds = feilds1.name
            })
        })
        this.setState({ 'table_head': table_head, 'table_body': table_body, 'add_more': add_more, 'add_more_title': add_more_title, 'tablebody_name': subfeilds })
    }

    updateTablebody() {
        let { table_from } = this.props;
        if (table_from === 'excludes_schema') {
            console.clear();
            let table_data = excludesUpdateTableStore.getState();
        }
    }

    handleChange(data) {
        this.props.change(data);  
    }

    addButton(currentIndex, fieldKey) {
        let { table_from, table_data } = this.props;
        try {
            let { table_body } = this.state;
            let last_element = table_body[table_body.length - 1];
            let add_more_feilds = table_data[fieldKey];
            let last_id = table_body.reduce((maxId, row) => Math.max(maxId, row.id), 0);
            let new_id = last_id + 1;
            let add_more = JSON.parse(JSON.stringify(add_more_feilds));
            add_more = add_more.map((feild) => ({
                ...feild,
                id: new_id,         
                value: null,
                text: null
            }));

            let newField = [{
                id: new_id,
                key_word: 'add_more',
                text: "Highend",
                type: "text",
                input_feild: [],
                feilds: add_more
            }];
            const insertIndex = currentIndex + 1;
            let updatedTableBody = [...table_body];
            updatedTableBody.splice(insertIndex, 0, newField[0]);
            
            if (table_from !== 'excludes_schema') {
                this.props.change(newField);
                this.setState((state) => ({ 'table_body': state.table_body.concat(newField) }));
            }
            if (table_from === 'excludes_schema') {
                this.setState((state) => ({ 'table_body': state.table_body.concat(newField) }));
            }
        } catch (error) {
            console.log(error);
        }
    }

    deleteRow(row_id) {
        let table_body = this.state.table_body;
        let { table_from, form_table } = this.props;

        // if (row_id) {
        try {
            if (table_body.length > 1) {
                let removed_obj = table_body.splice(row_id, 1);
                if (table_from !== 'excludes_schema') {
                    this.props.deleteLineItem(removed_obj);
                }
            } else {
                if (row_id === 0 && form_table !== 'additional_procedures' ) {
                    table_body.map((body, key) => {

                        if (key === row_id && body['feilds']) {
                            body['feilds'].map((feild, feild_key) => {
                                if (feild.name === 'excludes_service_id') {
                                    table_body[key]['feilds'][feild_key]['selected_option'] = null;
                                    table_body[key]['feilds'][feild_key]['value'] = null;
                                    table_body[key]['feilds'][feild_key]['text'] = null;
                                }
                                if (feild.name === 'additional_surgery_procedure_name') {
                                    table_body[key]['feilds'][feild_key]['selected_option'] = null;
                                    table_body[key]['feilds'][feild_key]['value'] = null;
                                    table_body[key]['feilds'][feild_key]['text'] = null;
                                }
                                // if (feild.name === 'additional_package_name') {
                                //     table_body[key]['feilds'][feild_key]['selected_option'] = null;
                                //     table_body[key]['feilds'][feild_key]['value'] = null;
                                //     table_body[key]['feilds'][feild_key]['text'] = null;
                                // }
                                if (feild.name === 'qty') {
                                    table_body[key]['feilds'][feild_key]['value'] = null
                                }
                                if (feild.name === 'rate') {
                                    table_body[key]['feilds'][feild_key]['value'] = null
                                }
                                if (feild.name === 'amount') {
                                    table_body[key]['feilds'][feild_key]['value'] = null;
                                }

                            })
                        }
                    })
                }
                if (row_id === 0 && (form_table === 'additional_procedures' || form_table === 'ailment_capping' || form_table ==='interim' || form_table ==='previlage' || form_table==='nme')) {
                    let removed_obj = table_body.splice(row_id, 1);
                    this.props.deleteLineItem(removed_obj);
                }
            }

            this.setState({ 'table_body': table_body }, () => {
                if (table_from === 'excludes_schema') {
                    let { table_body } = this.state;
                    excludesTableStore.dispatch({ type: 'options_data', 'data': table_body });
                }
            })


        } catch (error) {
            console.log(error);
        }
        // }
    }

    refreshRow = (index) => {
        let updatedTableBody = [...this.state.table_body];
        updatedTableBody[index].feilds = updatedTableBody[index].feilds.map(field => ({
            ...field,
            value: "",
            text: "",
            selected: false
        }));
        this.props.deleteLineItem1(updatedTableBody,index);
        this.setState({ table_body: updatedTableBody });
        console.log(`Data cleared for row ${index}`);
    };
    
    render() {
        let { table_head, table_body, add_more, add_more_title } = this.state;
        let {index} = this.props;
        let { slug } = this.props.match.params;
        const addMoreTitle = ['Add Investigation Charges', 'Add Service Charges', 'Add Pharmacy charges', 'Add OT/Cath Pharmacy', 'Add Procedure', 'Add Other miscellaneous charges','Add Consultation Fees', 'Additional Surgeon Fees', 'Additional Medical Fees','Add Additional package']
        if (slug === 'view-finanical-counselling') {
            add_more = false;
        }
        else if (slug === 'finanical-counselling') {
            if (addMoreTitle.includes(add_more_title)) {
                add_more = true;
            } else {
                add_more = false;
            }
        }

        const exceptionalTitles = ['Add Additional Procedure','Add Additional package']
        return (<table className="table table-hover table-bordered">
            <tbody>
                {table_body.length > 0 && table_body.map((feild, index) => {
                    const rowIndex = `${this.props.index}.${index + 1}`;
                    const procedureIndex = `${index + 1}`
                    // const shouldAddButton = ((isPharmacyCharges && index > 0));
                    let keyWord = null;
                    feild.feilds.map((subfeilds, key) => {
                        keyWord = subfeilds.row_group;
                    });
                    const KeyWords1 = ['ot_instruments', 'highend1'];
                    const KeyWords2 = ['implant','ot_equipment_charges'];
                    const KeyWords3 = ['ins_highend_investigation','ins_highend_services','ot_cath_highend','primary_consultation_room','surgeon_fees','physician_fees','bloodbank_charges','highend_procedure_charges','highend']
                    const isRow = add_more_title === 'Add Other miscellaneous charges' ? index === 1 : 
                    add_more_title === 'Add Consultation Fees' ? index === table_body.length - 7 : 
                    (add_more_title === 'Additional Medical Fees' || keyWord === 'ot_cath_highend') ? index === 0 : 
                    add_more_title === 'Additional Surgeon Fees' ? index === table_body.length - 4 : null;
                    const belongsToGroup = KeyWords1.includes(keyWord) || KeyWords2.includes(keyWord) || KeyWords3.includes(keyWord);
                    const isLastRow = table_body.map((row, idx) => 
                        row.feilds.some((field) => field.row_group === keyWord) ? idx : null).filter((idx) => idx !== null).pop() === index;
                    return (
                        <tr key={index}>
                            {(slug === 'view-finanical-counselling'&&feild.key_word==='in_asst_physician_fees')?<td>{exceptionalTitles.includes(add_more_title) ? procedureIndex : rowIndex}</td>:feild.key_word!=='in_asst_physician_fees'&&<td>{exceptionalTitles.includes(add_more_title) ? procedureIndex : rowIndex}</td>}

                            {feild.feilds.map((input, inkey) => {
                                if (input.visible && input.element === 'input') {
                                    return (
                                        <td key={inkey}>
                                            <InputNumberlayer {...this.props} {...this.state} selectdata={input} onInputChanges={this.handleChange.bind(this)} />
                                        </td>
                                    )
                                }
                                if (input.visible && input.element === 'select') {
                                    return (
                                        <React.Fragment key={index}>
                                            <td key={inkey}>
                                                <div className="row mx-0">
                                                    <div className="col px-0">
                                                        <Select2
                                                            selectdata={input}
                                                            changedObj={this.state.changedObj}
                                                            {...this.props}
                                                            {...this.state}
                                                            Queuedata={this.state.formData}
                                                            onselectChanges={this.handleChange.bind(this)} />
                                                        {input.errors.map((error, eKey) => {
                                                        return (
                                                                <small key={eKey} className="form-text text-danger" id={'errormalment'+input.id}>{error.message}</small>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            </td>
                                        </React.Fragment>
                                    )
                                }
                                if (input.visible && input.element === 'datepicker') {
                                    return (
                                        <td key={inkey}>
                                            <Datepicker selectdata={input}
                                                changedObj={this.state.changedObj}
                                                {...this.props}
                                                {...this.state}
                                                Queuedata={this.state.formData}
                                                onselectChanges={this.handleChange.bind(this)} />
                                        </td>
                                    )
                                }
                                if (input.visible && input.element === 'checkbox') {
                                    return (
                                        <td key={inkey}>
                                            <Checkboxlayer selectdata={input}
                                                changedObj={this.state.changedObj}
                                                {...this.props}
                                                {...this.state}
                                                Queuedata={this.state.formData}
                                                onselectChanges={this.handleChange.bind(this)} />
                                        </td>
                                    )
                                }
                                if (input.visible && input.element === 'action') {
                                    return (
                                        <td key={inkey}>
                                            <Tooltip placement="top" title='Remove'>
                                                <img src="/assets/images/icons/delete.png" alt="Remove" className="mr-2" onClick={this.deleteRow.bind(this, index)} />
                                            </Tooltip>
                                            {/* <Tooltip placement="top" title="Refresh">
                                                <img src="/assets/images/icons/refresh.png" alt="Refresh" className="ml-2" onClick={() => this.refreshRow(index)} />
                                            </Tooltip> */}
                                        </td>
                                    )
                                } else if ((slug === 'finanical-counselling' && slug === 'recounselling') && input.visible && (input.name === 'action' || input.name === 'select')) {
                                    return (
                                        <td key={inkey}>
                                            {/* <Tooltip placement="top" title='Remove'>
                                                <img src="/assets/images/icons/delete.png" alt="Remove" className="mr-2" onClick={this.deleteRow.bind(this, index)} />
                                            </Tooltip> */}
                                            <Tooltip placement="top" title="Refresh">
                                                <img src="/assets/images/icons/refresh.png" alt="Refresh" className="ml-2" onClick={() => this.refreshRow(index)} />
                                            </Tooltip>
                                        </td>
                                    )
                                }
                                if (input.visible && input.element === 'text') {
                                    return (
                                        <td key={inkey} colSpan={input.colSpan}>
                                            {input.tooltip ? <Tooltip   placement="topRight" color={'red'} title={input.tooltip}>{input.title}
                                                <InfoCircleOutlined style={{ "font-size": "16px", "margin-left": "20px" }} />
                                            </Tooltip> :input.text? input.text:input.title}
                                        </td>
                                    )
                                }
                                if(input.visible && input.element==='a'){
                                    let href = `${hostname}/counselling/view-document?uid=${input.umr_no}&ip=${input.ip_no}&name=${input.patient_name}&file=${input['text'] && input['text'].replaceAll("&", "_ampersand_")}`;
                                
                                if (slug === 'pre-auth-worklist' || slug === 'post-auth-worklist' || slug === 'query-worklist' || slug === 'gre-worklist' || slug === 'dmo-worklist') {
                                    href = `${UPLOAD_URL}${input.umr_no}/${input['text']}`;
                                }
                                    return (
                                        <td key={inkey}>
                                            <Tooltip title="Click to View"><a href={href} target="_blank" className="pr-2">{input['text']}</a></Tooltip>
                                        </td>
                                    )
                                }
                            })}
                                {(belongsToGroup && isLastRow && add_more ) && <tr>
                                    <td colSpan={table_head.length}>
                                        <Tooltip placement="top" title='Add' style={{height: '2%'}}>
                                            <img src="/assets/images/icons/plus.png" alt="Add" className="mr-2" onClick={() => (KeyWords1.includes(keyWord) ? this.addButton(index, 'add_more_feilds1'): KeyWords2.includes(keyWord) ? this.addButton(index, 'add_more_feilds2') : this.addButton(index, 'add_more_feilds'))}/>
                                        </Tooltip>
                                    </td>
                                </tr>
                                }
                        </tr>)
                })}

                {(exceptionalTitles.includes(add_more_title) ? add_more: null) && <tr>
                    <td colSpan={table_head.length} className="text-right">
                        <PlusOutlined className="btn btn-success" onClick={() => this.addButton(index, 'add_more_feilds')}></PlusOutlined>
                    </td>
                </tr>
                }
            </tbody>
        </table>)
    }
}

export default Tableantd;
